<template>
  <ModalUi @closeModal="closeModal" class="first-level-modal">
    <!-- <div class="modal-container"> -->
    <div class="modal-wrap">
      <div class="modal-block">
        <div class="modal-title">
          <h3>Выберите адрес на карте</h3>
        </div>
        <button class="close" @click="closeModal" type="button">
          <img src="/images/redesignedForm/close-button.svg" alt="close" />
        </button>
        <div>
          <div id="ymap_modal" class="yandex_map"></div>
          <div class="address-block">
            <div v-if="selectedAddress" class="address-description">
              <span><b>Выбранный адрес:</b> {{ selectedAddress }}</span>
            </div>
            <div v-else class="invalid-message">{{ errorMessage }}</div>
            <div class="address-controller">
              <button
                class="address-submit"
                :class="{
                  disabled: !isComplete,
                }"
                :disabled="!isComplete"
                @click="confirmAddress"
                type="button"
              >
                Выбрать
              </button>
              <div v-if="selectedAddress && !isComplete" class="error-message">
                Необходимо выбрать дом
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </ModalUi>
</template>

<script>
import selectOnMapMixins from '@apps/order-form/src/mixins/selectOnMap'
import ModalUi from '@features/UI/ModalUi.vue'

export default {
  name: 'MapModal',
  components: { ModalUi },
  mixins: [selectOnMapMixins],
}
</script>

<style lang="scss" scoped>
#ymap_modal {
  width: 100%;
  height: 60vh;
  margin-bottom: 20px;
}

.modal-block {
  // width: 640px;
  // max-width: 90%;

  // height: 67vh;
}

.address-block {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  min-height: 34px;

  .invalid-message {
    color: #de3e26;
  }

  .address-description {
    display: flex;
    align-items: center;

    min-height: 40px;
  }

  .address-controller {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    margin-left: 10px;

    .error-message {
      min-height: 20px;
      margin-top: 8px;

      text-align: center;
    }

    .address-submit {
      width: 180px;
      height: 40px;
      padding: 0 13px;

      color: white;

      background: #de3e26;
      border: none;
      border-radius: 20px;

      &.disabled {
        cursor: default;

        color: #969696;

        background: #e2e2e2;
      }
    }
  }
}

// Костыли (до переделки модальных окон)
.modal-title {
  .close {
    height: 100% !important;
  }

  h3 {
    font-size: 18px !important;
  }
}

@media (min-height: 768px) {
  .yandex_map {
    height: 500px;
  }
}
</style>
